// extracted by mini-css-extract-plugin
export var content = "info-module--content--LJHEC accordion-module--accordion-content--0lJF0";
export var heading = "info-module--heading--dTCcp typography-module--heading--AdW8T colors-module--color-body--wh0CY";